(function () {
    'use strict';

    angular
        .module('salesflare')
        .controller('EditPipelineDialogController', EditPipelineDialogController);

    function EditPipelineDialogController($scope, $mdDialog, $translate, currencies, flagsService, model) {

        $scope.pipeline = null;
        $scope.groupAccessPlaceholder = $translate.instant('Group access');
        $scope.showPlanFlags = function () {

            const onTrial = model.me.team.payment_type !== 'free' && !model.me.team.subscribed && model.me.trial_expiry_date;
            return (onTrial || !model.me.plan_flags.permissions);
        };

        $scope.canAccessPermissions = function () {

            return model.me.plan_flags.permissions;
        };

        $scope.canAccessMultipleCurrencies = () => {

            return flagsService.get('multipleCurrencies') === true;
        };

        $scope.groups = this.groups;
        $scope.defaultCurrency = model.me.team.currency;

        currencies.get().then(currenciesResponse, null, currenciesResponse);

        if (this.pipeline) {
            $scope.pipeline = this.pipeline;
            $scope.wasRecurring = this.pipeline.recurring;
        }
        else {
            $scope.pipeline = {
                groups: angular.copy($scope.groups),
                currency: null,
                follows_default_team_currency: true
            };
            $scope.isNew = true;
        }

        const originalPipeline = angular.copy($scope.pipeline);

        $scope.setPipelineFollowsDefaultCurrency = (val) => {

            $scope.pipeline.follows_default_team_currency = val;
        };

        $scope.getGroupsSelectedText = function () {

            if (!$scope.pipeline.groups || $scope.pipeline.groups.length === 0) {
                return $translate.instant('Group access') || 'Group access';
            }

            if ($scope.pipeline.groups.length === $scope.groups.length) {
                return $translate.instant('All groups') || 'All groups';
            }

            return $scope.pipeline.groups.map(function (pipeline) {

                return pipeline.name;
            }).join(', ');
        };

        $scope.save = function () {

            if (!$scope.pipelineForm.$valid || !$scope.pipeline) {
                return;
            }

            if ($scope.canAccessPermissions() && model.me.group) {
                const updatedPipelineGroupsContainOwnGroup = !!($scope.pipeline.groups.some(function (group) {

                    return group.id === model.me.group;
                }));
                const originalPipelineGroupsContainOwnGroup = !!(originalPipeline.groups.some(function (group) {

                    return group.id === model.me.group;
                }));

                if (originalPipelineGroupsContainOwnGroup && !updatedPipelineGroupsContainOwnGroup) {
                    const confirmGroupRemoval = $mdDialog.confirm({ multiple: true })
                        .clickOutsideToClose(true)
                        .escapeToClose(true)
                        .title($translate.instant('Are you sure?') || 'Are you sure?')
                        .textContent($translate.instant('If you remove access for your own group, you will not be able to see this pipeline anymore.') || 'If you remove access for your own group, you will not be able to see this pipeline anymore.')
                        .ok($translate.instant('I\'m sure') || 'I\'m sure')
                        .cancel($translate.instant('cancel') || 'cancel');

                    return $mdDialog.show(confirmGroupRemoval).then(function () {

                        if (!$scope.isNew && $scope.wasRecurring && !$scope.pipeline.recurring) {
                            const confirm = $mdDialog.confirm({ multiple: true })
                                .htmlContent($translate.instant('Switching off recurring revenue will make all opportunity values one-time values. <br/> You will lose all data about the recurring contracts. Do you want to continue?') || 'Switching off recurring revenue will make all opportunity values one-time values. <br/> You will lose all data about the recurring contracts. Do you want to continue?')
                                .ok($translate.instant('Yes') || 'Yes')
                                .cancel($translate.instant('No') || 'No');

                            return $mdDialog.show(confirm).then(function () {

                                // Hiding the parent dialog
                                return $mdDialog.hide($scope.pipeline);
                            });
                        }

                        return $mdDialog.hide($scope.pipeline);
                    }).catch(function () {

                        $scope.pipeline.groups = originalPipeline.groups;
                    });
                }
            }

            if (!$scope.isNew && $scope.wasRecurring && !$scope.pipeline.recurring) {
                const confirm = $mdDialog.confirm({ multiple: true })
                    .htmlContent($translate.instant('Switching off recurring revenue will make all opportunity values one-time values. <br/> You will lose all data about the recurring contracts. Do you want to continue?') || 'Switching off recurring revenue will make all opportunity values one-time values. <br/> You will lose all data about the recurring contracts. Do you want to continue?')
                    .ok($translate.instant('Yes') || 'Yes')
                    .cancel($translate.instant('No') || 'No');

                return $mdDialog.show(confirm).then(function () {

                    // Hiding the parent dialog
                    return $mdDialog.hide($scope.pipeline);
                });
            }

            return $mdDialog.hide($scope.pipeline);
        };

        $scope.close = $mdDialog.hide;

        function currenciesResponse(response) {

            $scope.currencies = response.data;
        }
    }
})();
